module.exports = __webpack_public_path__ + "media/images/illustrations/cloud_side_image-d8bc8eefb9f690c2b83d596ebded09ee.png";